import './Community.css'
import { useTranslation } from 'react-i18next'

import { Header } from '../../components/Header/Header.js'
import { Input } from '../../components/Input/Input'
import { Button } from '../../components/Button/Button'

const Community = () => {
	const { t } = useTranslation()

	return (
		<>
			<Header
				className="header-container"
				backButton={true}
				subtitle={t('Community')}
			/>

			<div className="community__container">
				<div className="community__wrapper">
					<div className="form-input" style={{ position: 'relative' }}>
						<label className="form-input__label" htmlFor="password">{t('Name')}</label>

						<div className="form-input__password">
							<Input
								type="text"
							/>
						</div>
					</div>

					<div className="form-input" style={{ position: 'relative' }}>
						<label className="form-input__label" htmlFor="password">{t('Country')}</label>

						<div className="form-input__password">
							<Input
								type="text"
							/>
						</div>
					</div>

					<div className="form-input" style={{ position: 'relative' }}>
						<label className="form-input__label">{t('Community language')}</label>

						<div className="form-input__password">
							<Input
								type="text"
							/>
						</div>
					</div>

					<Button type={'submit'} title={t('Save')} />
				</div>
			</div>
		</>
	)
}

export default Community
